import { Box, Typography, Checkbox, FormControlLabel, Chip, TextField, MenuItem, Divider } from '@mui/material';
import { ReceiptItem as ReceiptItemType, ReceiptItemProps } from '../types/types';

export const ReceiptItem = ({
  item,
  selected,
  onToggle,
  users,
  selectedUsers,
  onUserSelect,
  onShareChange,
  userShares,
  totalShares
}: ReceiptItemProps) => {
  const unitPrice = item.pricePerUnit ?? (item.price / item.quantity);
  const totalPrice = item.price;

  const getAvailablePortions = (currentUser: string) => {
    const currentUserShare = userShares[currentUser] || 0;
    const remaining = item.quantity - (totalShares - currentUserShare);

    if (item.quantity === 1) {
      return [
        { value: 0, label: 'Не ел' },
        { value: 0.25, label: '¼ порции' },
        { value: 0.33, label: '⅓ порции' },
        { value: 0.5, label: '½ порции' },
        { value: 0.75, label: '¾ порции' },
        { value: 1, label: 'Всю порцию' }
      ];
    } else {
      return [
        { value: 0, label: 'Не ел' },
        ...Array.from({ length: Math.min(remaining, item.quantity) }, (_, i) => ({
          value: i + 1,
          label: `${i + 1} порция`
        }))
      ];
    }
  };

  return (
    <Box border={1} borderColor="#e0e0e0" borderRadius={1} p={2} mb={2}>
      <FormControlLabel
        control={<Checkbox checked={selected} onChange={() => onToggle()} />}
        label={
          <Box width="100%">
            <Typography fontWeight="bold">
              {item.name} {item.quantity > 1 && `(x${item.quantity})`}
            </Typography>
            <Typography color="text.secondary">
              {unitPrice.toFixed(2)} ₽ {item.quantity > 1 && `× ${item.quantity} = ${totalPrice.toFixed(2)} ₽`}
            </Typography>
            {selected && item.quantity > 1 && (
              <Typography variant="caption">
                Доступно: {item.quantity - totalShares} из {item.quantity} порций
              </Typography>
            )}
          </Box>
        }
      />

      {selected && (
        <Box mt={2}>
          <Divider sx={{ mb: 2 }} />
          <Typography variant="subtitle2">Распределение:</Typography>
          
          {users.map(user => (
            <Box key={user} display="flex" alignItems="center" gap={1} mb={1}>
              <Chip
                label={user}
                onClick={() => onUserSelect(user)}
                color={selectedUsers.includes(user) ? 'primary' : 'default'}
                variant={selectedUsers.includes(user) ? 'filled' : 'outlined'}
              />
              
              {selectedUsers.includes(user) && (
                <TextField
                  select
                  size="small"
                  value={userShares[user] || 0}
                  onChange={(e) => onShareChange(user, Number(e.target.value))}
                  sx={{ minWidth: 160 }}
                >
                  {getAvailablePortions(user).map(option => (
                    <MenuItem key={option.label} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
              )}
            </Box>
          ))}
        </Box>
      )}
    </Box>
  );
};